function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.621094 4.86649C0.621094 3.47558 1.6431 2.296 3.01982 2.09791L16.8921 0.101898C17.3618 0.0343139 17.8388 0.0343139 18.3085 0.101898L32.1808 2.09791C33.5575 2.296 34.5795 3.47559 34.5795 4.86649V30.2251C34.5795 31.8967 33.7396 33.4565 32.344 34.3766L20.3374 42.2926C18.6769 43.3873 16.5238 43.3874 14.8632 42.2926L2.85661 34.3766C1.461 33.4565 0.621094 31.8967 0.621094 30.2251V4.86649Z",
  fill: "url(#igcs_paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.357 0.705108L18.1651 0.101957C17.6954 0.0343736 17.2184 0.0343736 16.7487 0.101957L12.5561 0.70521L14.4536 3.40044C14.698 3.74763 14.7999 4.17538 14.7382 4.59548L11.6641 25.5275C11.5956 25.9936 11.7287 26.4668 12.0301 26.8288L16.1826 31.8172C16.8453 32.6133 18.0677 32.6133 18.7304 31.8172L22.8829 26.8288C23.1843 26.4668 23.3174 25.9936 23.2489 25.5275L20.1748 4.59548C20.1131 4.17538 20.215 3.74763 20.4594 3.40044L22.357 0.705108Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "igcs_paint0_linear",
  x1: 17.6003,
  y1: 0,
  x2: 17.6003,
  y2: 44.0971,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE6C03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE03C7"
})));

function SvgIconGcShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 45,
    viewBox: "0 0 35 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGcShield);
export default __webpack_public_path__ + "static/media/icon-gc-shield.edce6b6e.svg";
export { ForwardRef as ReactComponent };